<template>
  <div div class="addPerson__wrap" v-show="visible">
    <el-button style="margin:20px;" plain icon="el-icon-d-arrow-left" @click="toggle(false)">返回</el-button>
    <div class="main">
      <el-radio-group v-model="status" @change="handleRadio" style="margin-bottom:20px;">
        <el-radio-button :label="1">注册信息</el-radio-button>
        <el-radio-button :label="2">实名认证</el-radio-button>
        <el-radio-button :label="3" v-if="this.userType === 2">名片信息</el-radio-button>
        <el-radio-button :label="4" v-if="this.userType === 2">完工照片</el-radio-button>
        <el-radio-button :label="5">处罚记录</el-radio-button>
      </el-radio-group>
      <template v-if="this.page === 1">
        <el-divider content-position="left">注册信息</el-divider>
        <div class="info-top">
          <div style="text-align:left;">
            <p>名称：{{dataInfo.register.name}}</p>
            <p>注册账号：{{dataInfo.register.account}}</p>
            <p>注册时间：{{dataInfo.register.create_time}}</p>
          </div>
          <img
            v-if="dataInfo.register.avatar"
            style="width: 80px; height: 80px;margin-left:50px;object-fit: contain;"
            :src="dataInfo.register.avatar"
            />
          <img
            v-else
            style="width: 80px; height: 80px;margin-left:50px;object-fit: contain;"
            :src="dataInfo.certification.sex === 1 ? sex1 : dataInfo.certification.sex === 2 ? sex2 : sex0"
            />
        </div>
      </template>
      <!-- 实名认证 -->
      <template v-if="this.page === 2">
        <el-descriptions title="" :column="1" border v-if="!!dataInfo.certification.id_card">
          <el-descriptions-item label="认证时间">{{dataInfo.certification.create_time}}</el-descriptions-item>
          <el-descriptions-item label="姓名">{{dataInfo.certification.name}}</el-descriptions-item>
          <el-descriptions-item label="性别">{{dataInfo.certification.sex === 1 ? '男' : '女'}}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{dataInfo.certification.id_card}}</el-descriptions-item>
          <el-descriptions-item label="出生日期">{{dataInfo.certification.birthday}}</el-descriptions-item>
          <el-descriptions-item label="户籍地址">{{dataInfo.certification.native}}</el-descriptions-item>
          <el-descriptions-item label="身份证照片">
            <el-image
              v-if="dataInfo.certification.card_url"
              style="width: 200px; height: 150px"
              :src="dataInfo.certification.card_url"
              fit="cover"
              :preview-src-list="[dataInfo.certification.card_url]"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <p v-else>无认证信息</p>
      </template>
      <!-- 名片信息 只有师傅端显示 -->
      <template v-if="this.page === 3">
        <el-descriptions title="" :column="1" border v-if="dataInfo.certification.name">
          <el-descriptions-item label="年龄" :labelStyle='labelStyle'>{{dataInfo.certification.age}}</el-descriptions-item>
          <el-descriptions-item label="身份" :labelStyle='labelStyle'>{{toStr({0:'未填',1:'学生',2:'自由职业',3:'宝妈',4:'全职'},dataInfo.certification.type)}}</el-descriptions-item>
          <el-descriptions-item label="擅长工种" :labelStyle='labelStyle'>{{dataInfo.certification.kinds}}</el-descriptions-item>
          <el-descriptions-item label="联系电话" :labelStyle='labelStyle'>{{dataInfo.certification.phone}}</el-descriptions-item>
          <el-descriptions-item label="所在地址" :labelStyle='labelStyle'>
            <!-- <div>{{dataInfo.certification.address}}</div> -->
            <div>{{dataInfo.certification.map_address}}</div>
          </el-descriptions-item>
          <el-descriptions-item label="服务地区" :labelStyle='labelStyle'>{{dataInfo.certification.other_area_str.join(',')}}</el-descriptions-item>
          <el-descriptions-item label="技能证书" :labelStyle='labelStyle'>
            <span v-if="dataInfo.certification.is_certificate == 2">不涉及</span>
            <div v-else style="display:flex">
              <div v-for="(i,idex) in dataInfo.certification.kind_certificate" :key="idex" style="margin-right:10px;display: flex;flex-direction: column;align-items: center;">
                <template v-if="i.image">
                  <div style="width:60px;height:40px;cursor:pointer" @click="previewCert(i.image)">
                    <el-image style="width:100%;height:100%" :src="i.image">
                      <div slot="error">暂无照片</div>
                    </el-image>
                  </div>
                  <div style="text-align:center">{{i.name}}</div>
                </template>
                <template v-else>
                  <img style="width:60px;height:40px" :src="require('@/assets/img/no-pic.png')" alt="">
                  <div style="text-align:center;margin-top: 4px;">{{i.name}}</div>
                </template>
              </div>
            </div>
          </el-descriptions-item>
        </el-descriptions>
        <p v-else>无名片信息</p>
      </template>
      <!-- 完工照片 只有师傅端显示 -->
      <template v-if="this.page === 4">
        <el-descriptions direction="vertical" title="" :column="1" :colon="false" v-if="dataInfo.order.length > 0">
          <el-descriptions-item :label="item.complete_time" v-for="item in dataInfo.order" :key="item">
            <span v-for="img in item.complete_image" :key="img" style="margin-right:10px;">
              <el-image
                style="width: 80px; height: 80px"
                :src="img"
                fit="cover"
                :preview-src-list="[img]"></el-image>
            </span>
          </el-descriptions-item>
        </el-descriptions>
        <p v-else>无完工照片</p>
      </template>
      <!-- 处罚记录 -->
      <template v-if="this.page === 5">
        <p>账号状态： {{dataInfo.register.status === 1 ? '正常' : '异常'}}</p>
        <p v-if="dataInfo.register.status === 1">处罚记录：无</p>
        <el-table
          v-else
          :data="dataInfo.punish"
          border
          style="width: 100%"
          :header-cell-style="{background:'#FAFAFA'}"
          >
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="处罚时间"
            width="180">
          </el-table-column>
          <el-table-column
            prop="reason"
            label="处罚原因"
            width="180">
          </el-table-column>
          <el-table-column
            prop="job_title"
            label="关联工单">
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="封号期限">
            <template v-slot="scope">
              <span v-if="scope.row.disable_time !== 1">{{scope.row.start_time}}至{{scope.row.disable_time}}</span>
              <span v-else>永久封号</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
     <!-- 技能证书预览（带水印） -->
    <el-dialog
      append-to-body
      width="700px"
      custom-class="cert-preview-dialog"
      :visible.sync="certPreviewVisible"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :show-close="false"
    >
      <div class="cert-preview-outer">
        <div class="cert-preview-wrap">
          <img :src="certPreviewUrl" class="cert-preview-img" />
          <div class="cert-watermark">
            <div v-for="r in 4" :key="'r'+r" class="wm-row">
              <span v-for="c in 4" :key="'c'+r+'-'+c" class="wm-cell">悟有空管理端</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sex1 from '@/assets/img/sex1.png';
import sex2 from '@/assets/img/sex2.png';
import sex0 from '@/assets/img/logo.png';
export default {
  name: 'UserDetail',
  data() {
    return {
      sex1,
      sex2,
      sex0,
      visible: false,
      certPreviewVisible: false,
      certPreviewUrl: '',
      dataInfo: {
        register: {},
        certification: {},
        punish: [],
        order: {}
      },
      page: 1,
      status: 1,
      userType: '',
      labelStyle: { 'width': '160px' },
    }
  },
  methods: {
    previewCert(url) {
      this.certPreviewUrl = url
      this.certPreviewVisible = true
    },
    // 获取详情
    getDetail(row, userType) {
      this.status = 1;
      this.page = 1;
      this.isChange = true
      this.userType = Number(userType)
      console.log(this.userType)
      this.$http.get('/admin/flex_user/info', {params:{id: row.id} }).then(res => {
        if(res.code === 1) {
         this.dataInfo = res.data
          this.dataInfo.happen_at = this.$moment(res.data.created_at).format('YYYY-MM-DD')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    reset(done) {
      this.status = 1
      this.page = 1
      this.dataInfo = {
        register: {},
        certification: {},
        punish: [],
        order: {}
      }
      this.isChange = false
      // this.$refs.elFormDom.resetFields()
      done && done()
    },
    toggle(show) {
      this.visible = show
      !show && this.reset()
    },
    handleRadio(value) {
      this.page = value
    },
    toStr(data, key) {
      return data[key]
    }
  }
}
</script>
<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
  background-color: #fff;
  margin: 10px;
  z-index: 5 !important;
  overflow: scroll;
  .main {
    width: 80%;
    margin: 0 auto;

    .info-top{
      display: flex;
      justify-content: start;
      align-items: center;
    }

    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .time {
      font-size: 18px;
      color: #8C8C8C;
      margin-bottom: 20px;
    }
  }
  
}
.portrait {
  text-align: center;
}
.portrait ::v-deep .el-avatar--large {
  width: 60px;
  height: 60px;
  line-height: 40px;
}
.no-img-box {
  width: 60px;
  height: 40px;
  border: 1px solid #999;
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f8f8;
}
/* 两条交叉斜线 */
.no-img-box::before,
.no-img-box::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  background: #999;
}
.no-img-box::before {
  transform: rotate(45deg);
}
.no-img-box::after {
  transform: rotate(-45deg);
}
/* 文字样式 */
.no-img-text {
  font-size: 12px;
  color: #333;
  z-index: 1;
}

.cert-preview-outer {
  text-align: center;
}
.cert-preview-wrap {
  position: relative;
  display: inline-block;
  .cert-preview-img {
    max-width: 100%;
    max-height: 600px;
    display: block;
  }
  .cert-watermark {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
    transform: rotate(-30deg);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .wm-row {
      display: flex;
      justify-content: space-around;
      .wm-cell {
        color: rgba(204, 204, 204, 1);
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 2px;
        white-space: nowrap;
      }
    }
  }
}
</style>
<style lang="scss">
.cert-preview-dialog .el-dialog__header {
  padding: 10px 20px;
}
.cert-preview-dialog .el-dialog__body {
  padding: 10px 20px 20px;
}
</style>